
<div class="l_cln_medical_interviews">
  <div class="m_cln_medical_interviews_photo">
      <app-label-text title=""></app-label-text>
      <img :src="imageurl" class="">
  </div>
</div>
